import React, { useState } from 'react';
import { Container, Typography, Box, Alert } from '@mui/material';
import { changePass } from '../services/changePass';
import { useParams } from 'react-router-dom'; 
import { STPButton } from '../components/Botones';
import { CustomTextField } from '../components/Inputs';
import Logo from '../assets/Logo_Color_Training.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PasswordReset = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [changeError, setChangeError] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setError(t("password_reset.confirmPassword"));
      return;
    }

    if (password !== confirmPassword) {
      setError(t("password_reset.passwordMismatch"));
      return;
    }

    if (password.length < 8 || confirmPassword.length > 15) {
      setError(t('fields.passwordLength'))
      return;
    }
    else if (!password.match(/[a-z]/) || !password.match(/[A-Z]/) || !password.match(/[0-9]/)) {
      setError(t('fields.passwordComplexity'))
      return;
    }

    setError('');

    changePass(token, password)
    .then(response => {
      if (response?.data?.message === 'Contraseña cambiada correctamente'){
        setSuccess(true);
        setChangeError(false);
      } else {
        setSuccess(false);
        setChangeError(true);
      }
    }
    )

  };

  return (
    <Container sx={{ height: "100vh"}}>
      <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mt: 8,
          mb: 5,
          }}>
          <img src={Logo} alt="VilaTraining Logo" style={{ height: '100px' }} />
      </Box>
      <Box textAlign="center" mb={3}>
        <Typography variant="h5" component="h1">
          <b>{t("password_reset.title")}</b>
        </Typography>
      </Box>
      <form onSubmit={handleSubmit}>
        <CustomTextField
          fullWidth
          label={t("password_reset.newPassword")}
          type="password"
          variant="outlined"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={Boolean(error)}
        />

        <CustomTextField
          fullWidth
          label={t("password_reset.newPassword")}
          type="password"
          variant="outlined"
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={Boolean(error)}
          helperText={<Typography variant="caption" color="error" ml="18px">{error}</Typography>}
          InputProps={{
            sx: {
              '& .MuiFormHelperText-root': {
                color: 'red', // Estilo aplicado directamente al helperText
              },
            },
          }}
        />

        <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
          <STPButton type="submit" variant="contained" color="primary" sx={{ width: '80%'}}>
            {t("password_reset.changePassword")}
          </STPButton>
        </Box>
      </form>
      {success && (
        <Box mt={3}>
          <Alert severity="success">{t("password_reset.changeSuccess")}</Alert>
        </Box>
      )}
      {changeError && (
        <Box mt={3}>
          <Alert severity="error">{t("password_reset.changeError")}</Alert>
        </Box>
      )}
    </Container>
  );
};
